import { Injectable } from '@angular/core';
import { BehaviorSubject, of, Subject, Subscription } from 'rxjs';
import { CustomerModel } from 'src/app/models/customer-model';
import { ConfigService } from '../config/config.service';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';
import { EventsService } from '../event/event.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { BonusContent } from 'src/app/popovers/bonus-content/bonus-content.page';
import { AuthenticationService } from '../authentication/authentication.service';
import { delay, distinctUntilChanged, filter, map, takeUntil } from 'rxjs/operators';
import { AvatarService } from './avatar.service';
import { NotificationHandlerService } from '../notification-handler/notification-handler.service';

@Injectable({
  providedIn: 'root'
})

export class LevelService {
 
 

  levelTiers: any;
  timeoutId: any;
  timeout:any;

  public customer: CustomerModel;
  public customerId: number;
  public currentLevel: number;

  private levelSubject = new BehaviorSubject<number>(0);
  level$ = this.levelSubject.asObservable();

  private progressSubject = new BehaviorSubject<number>(0);
  progress$ = this.progressSubject.asObservable();
  private customerSubscription: Subscription | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private config: ConfigService,
    private notificationHandler:NotificationHandlerService,
    private userSession: UserSessionService,
    private webservices: WebservicesService,
    private events: EventsService,
    private navigator: Navigator,
    private authenticationService:AuthenticationService,
    private avatarService:AvatarService
  ) {

    this.userSession.getCustomer().subscribe((customer) => {
      if (customer) {
        this.customer = customer;
      }
    });

    this.getCustomerUniqueID();

    this.config.isLoaded().then((config) => {
      setTimeout(() => { 
        this.initLevelsTiers();
        this.avatarService.getAvatarList();
        if(this.customer){
          this.getInitialLevel(); 
        }
      }, 400);
    });

    // this.events.subscribe("event:login", () => {
    //   setTimeout(() => { this.getInitialLevel(); }, 400);
    // });

    // this.events.subscribe("show:welcome:dialog",() => {
    //   setTimeout(() => { this.getInitialLevel(); }, 200);
    // })
  }

  getInitialLevel() {

    this.callGetLoyaltyPoints().subscribe(res => {
      const level = res?.payload?.current_loyalty_level;
      this.currentLevel = level;
      this.updateLevel(level);
      this.updateProgress(res?.payload?.current_progress);
    });
  }

  getCustomerUniqueID(){
    this.customerSubscription?.unsubscribe();
    this.userSession.getCustomerSubscription().then((obs) => {
      this.customerSubscription = obs
        .pipe(
          takeUntil(this.destroy$),
          filter((customer) => !!customer),
          map((customer) => customer.customerId),
          distinctUntilChanged()
        )
        .subscribe((customerId) => {
          if (customerId) {
            this.customerId = customerId;
          }
        });
    }); 
  }

  initLevelsTiers() {
    this.callGetAllLoyaltyTiers().subscribe(res => {
      if(!!res.result){
        this.levelTiers = res.payload;

      }
    });

  }

  callGetAllLoyaltyTiers(){
    let clientapp = this.config.getClientApp();
    const obj: any = {
      clientapp: clientapp
    }
    return this.webservices.get('configuration/get-loyalty-tiers', obj);
  }

  checkLevel(newLevel, awardPoints?, new_feature?) {
    this.userSession.isAuthenticated().then((isAuthenticated) => {
      if (isAuthenticated) {
        // this.callGetLoyaltyPoints().subscribe(async res => {
          // const level = res?.payload?.current_loyalty_level;
          const level = newLevel;

          
          this.currentLevel = level;
          this.updateLevel(this.currentLevel);


          
          this.level$.subscribe(level => {
            this.currentLevel = level;
            // this.checkNewFetures(new_feature);
          });
         
         // Set Initial value to false if not stored in custom properties.
          if(awardPoints){
            if(this.notificationHandler.genericPopupShown){
              return this.scheduleLevelUp(level,awardPoints);
            }
            this.showLevelUpDialog(level, awardPoints)
          }
      }
    });
  }
  
  scheduleLevelUp(level,awardPoints){
   this.timeout =  this.config.getConfig().FEATURE_LEVELUP_TIMEOUT??2000;
    this.timeoutId = setTimeout(() => {
      if(this.notificationHandler.genericPopupShown){
       this.scheduleLevelUp(level,awardPoints);
      }else{
        this.showLevelUpDialog(level, awardPoints);
      }
    }, this.timeout);
  }
  showLevelUpDialog(level, rewardedPoints) {
    return new Promise((resolve, reject) => {
      let timeOut = 4000;
      const data: BonusContent = {
        isAutoHideEnabled: true,
        isAutoHideTimeout: timeOut,
        isFromLevel: true,
        rewardedPoints: rewardedPoints,
        istopLeft: !(level <= 2)
      }
      const popoverComp = 'BonusContentPage';
      this.navigator.openPopover(popoverComp, data, "auto-dismiss-popover", true, true, true, -1, 'cover', false);
      setTimeout(() => {
        resolve(true);
      }, timeOut);

      // Popup for Leaderboard congrats and followed by avatar component
      setTimeout(() => {
        if(level === Number(this.config.getConfig().PIGGY_BANK_REQUIRED_LEVEL)){
          this.userSession.getCustomer().subscribe(
            (customer: CustomerModel) => {
            if (customer) {
              this.userSession.isAuthenticated().then(isAuth => {
                if(isAuth){
                    if(customer.getCustomDataProperty('PB_TUTORIAL_VIEWED') === "false" || customer.getCustomDataProperty('PB_TUTORIAL_VIEWED') === undefined || customer.getCustomDataProperty('PB_TUTORIAL_VIEWED') === null){
                      this.navigator.navigateTo('PiggyBankTutorialComponent',{ customModalClass: 'custom-piggy-model-class-transparent', backdropDismiss: true })
                        this.setTutorial('PB_TUTORIAL_VIEWED',"true");
                    }
                  }
              })
            }
          });
        }
        if(level === Number(this.config.getConfig().LEADERBOARD_LOYALTY_REQUIRED_LEVEL)){
          this.navigator.navigateTo('LeaderboardCongratsPopupComponent',{ customModalClass: 'custom-piggy-model-class-transparent', backdropDismiss: true })
        }
      }, 1000);
    });
  }


  callGetLoyaltyPoints() {
    const obj: any = {
      customer_id: this.customerId,
      session_token: this.userSession?.sessionToken
    }
    return this.webservices.get('rewards/get-loyalty-points', obj);

    // const fakeResponse = {
    //   "result" : 1,
    //   "payload" : {
    //     "current_loyalty_points" : 12096.00,
    //     "current_loyalty_level" : 8,
    //     "current_level_name" : "Tier 5",
    //     "current_progress" : 3.20,
    //     "next_level" : "2904.00",
    //     "next_level_points" : "2904.00",
    //     "next_level_name" : "Tier 6",
    //     "next_level_award" : {
    //       "PLAY" : 500
    //     }
    //   }
    // };
    // return of(fakeResponse).pipe(delay(1000));
  }

  public updateLevel(newLevel: number): any {
    this.levelSubject.next(newLevel);
  }

  public updateProgress(progress: number): any {
    this.progressSubject.next(progress);
  }

  public checkPiggyBankAvailable() {
    return this.currentLevel >= Number(this.config.getConfig().PIGGY_BANK_REQUIRED_LEVEL);
  }

  public checkLeaderBoardAvailable() {
    return this.currentLevel >= Number(this.config.getConfig().LEADERBOARD_LOYALTY_REQUIRED_LEVEL);
  }

  public checkDrawerAvailable(): any {
    return this.checkPiggyBankAvailable() || this.checkLeaderBoardAvailable();
  }

  public checkNewFetures(features_unlocked) {
   
   if(features_unlocked !== null && features_unlocked !== undefined) {
    let featuresArray = features_unlocked.split(',');
    if(featuresArray.includes('PIGGY_BANK')){
      if(this.customer.getCustomDataProperty("PB_TUTORIAL_VIEWED") === null 
          ){
            this.setTutorial('PB_TUTORIAL_VIEWED',"false");
          }
    }
    if(featuresArray.includes('LEADERBOARD')){
      if(this.customer.getCustomDataProperty("LB_TUTORIAL_VIEWED") === null ){
            this.setTutorial('LB_TUTORIAL_VIEWED',"false");
          }
    }
   }
  }

  updateProgressFromClient(e: any) {
    let currenLlytBalance =  e.parametersMap.amount;
    let currentTierOrder  = this.currentLevel;

    let currentLevelStart  = this.levelTiers.filter( tier => {
      return tier.tierOrder == currentTierOrder;
    })[0].pointsRequired;

    let nexTirePointsRequired  = this.levelTiers.filter( tier => {
        return tier.tierOrder == currentTierOrder + 1;
    })[0].pointsRequired;
    if(((currenLlytBalance - currentLevelStart) / (nexTirePointsRequired - currentLevelStart)) * 100 <= 100){
      this.updateProgress((((currenLlytBalance - currentLevelStart) / (nexTirePointsRequired - currentLevelStart)) * 100));
    }
    else {
      // level updated - fetch new level and progress
      this.getInitialLevel()
    }
  }
  
  
  setTutorial(tutorial: string, flag?:string) {
    let tutorialProps: any = [];
    tutorialProps["propName"] = tutorial;
    tutorialProps["propValue"] = flag;
    this.authenticationService
      .updateCustomData(tutorialProps)
      .subscribe((resp) => {
        this.userSession.refreshCustomer();
      });
  }

}
